/* Lead time message global initializer.
 *
 * Usage:
 * - Include this file once in your theme JS bundle.
 * - Render `lead-time/lead-time-message-global.liquid` where product info exists.
 *
 * Behavior:
 * - Finds containers with [data-lead-time-message-scope] and initializes them.
 * - Fetches leadTime from /apps/api/products-lead-time.
 * - Shows the message only when leadTimeDays > 0 and enforceUserAgreement is true.
 * - Works for quick view rendered via innerHTML (no inline script execution).
 */
(function () {
  if (window.LeadTimeMessageGlobalInit) {
    return;
  }

  function initContainer(container) {
    if (!container || container.dataset.leadTimeMessageBound) {
      return;
    }

    var productId = container.getAttribute('data-product-id');
    if (!productId || !/^\d+$/.test(productId)) {
      return;
    }

    container.dataset.leadTimeMessageBound = '1';

    fetch('/apps/api/products-lead-time', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ productIds: [productId] })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Lead time endpoint error: ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        var leadTime = data && data.leadTime ? data.leadTime : data;
        if (
          !leadTime ||
          typeof leadTime.leadTimeDays !== 'number' ||
          leadTime.leadTimeDays <= 0
        ) {
          return;
        }
        if (!leadTime.enforceUserAgreement) {
          return;
        }

        container.textContent = `Product will be available for shipping in ${leadTime.leadTimeDays}${leadTime.leadTimeDays > 1 ? ' days.' : ' day.'}`;
        container.style.display = 'block';
      })
      .catch(function (error) {
        console.error('lead time message global error:', error);
      });
  }

  function scan(scope) {
    if (!scope || !scope.querySelectorAll) {
      return;
    }
    scope
      .querySelectorAll('[data-lead-time-message-scope]')
      .forEach(function (container) {
        initContainer(container);
      });
  }

  function scanShadowRoots() {
    document.querySelectorAll('quick-buy-modal').forEach(function (modal) {
      if (modal.shadowRoot) {
        scan(modal.shadowRoot);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
    scanShadowRoots();
  });

  document.addEventListener('quick-view:open', function () {
    var drawer = document.getElementById('Product-Drawer-Content');
    if (drawer) {
      scan(drawer);
    } else {
      scan(document);
    }
  });

  var rootObserver = new MutationObserver(function () {
    scan(document);
    scanShadowRoots();
  });
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.LeadTimeMessageGlobalInit = {
    scan: scan,
    init: initContainer
  };
})();
